import configApp from '@/config'
import Vue from 'vue'

let utils = new Vue({
  data () {
    return {
      academyDomain: configApp.academyDomain,
      apiKeyTinyMce: configApp.apiKeyTinyMce,
      appDomain: configApp.appDomain,
      generatorPdfDomain: configApp.pdfGeneratorDomain,
      marketPlaceDomain: configApp.marketPlaceDomain,
      showAsideNavigationMenu: true,
      universityDomain: configApp.universityDomain
    }
  },

  methods: {
    addDaysToDate (date, days) {
      var dat = new Date(date)
      dat.setDate(dat.getDate() + days)
      return `${dat.getUTCFullYear()}-${dat.getUTCMonth() + 1}-${dat.getUTCDate()}`
    },

    bottomPage () {
      window.scrollTo(0, document.body.scrollHeight)
    },

    bottomVisible () {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },

    formatISODateTime (date, isDateTime = false) {
      let fecha = date.split('T')
      return isDateTime ? `${fecha[0]} ${(fecha[1]).split('-')[0]}` : fecha[0]
    },

    frequency (frecuencia) {
      switch (frecuencia) {
        case 1: return 'days'
        case 2: return 'weeks'
        case 3: return 'months'
        case 4: return 'years'
      }
    },

    getAcademyDomain () {
      return this.academyDomain
    },

    getAppDomain () {
      return this.appDomain
    },

    getCssVariable (variable) {
      return getComputedStyle(document.documentElement).getPropertyValue(variable)
    },

    getPaymentFrequency (cuotas, frecuencia, intervalo) {
      return cuotas === 1
        ? '1 pago'
        : cuotas === 0
          ? `1 pago cada ${intervalo || 1} ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
          : `${cuotas} cuotas mensuales`
    },

    getGeneratorPdfDomain () {
      return this.generatorPdfDomain
    },

    getMarketPlaceDomain () {
      return this.marketPlaceDomain
    },

    getUniversityDomain () {
      return this.universityDomain
    },

    hexToRgb (hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
      })

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : null
    },

    hideAsideNavigationMenu () {
      let documentViewportLandscape = document.documentElement.clientWidth
      let appViewportLandscape = this.getCssVariable('--app-viewport-landscape').replace('px', '')
      this.showAsideNavigationMenu = !(documentViewportLandscape <= appViewportLandscape)
    },

    isUrl (str) {
      var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/
      return regexp.test(str)
    },

    newDate (date) {
      let fecha = date.split('-')
      return new Date(fecha[0], fecha[1] - 1, fecha[2])
    },

    parseVideo (url, autoplay = false) {
      // - Supported YouTube URL formats:
      //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
      //   - http://youtu.be/My2FRPA3Gf8
      //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
      // - Supported Vimeo URL formats:
      //   - https://vimeo.com/401102477
      //   - https://vimeo.com/401102477?share=copy
      //   - https://player.vimeo.com/video/401102477
      //   - https://player.vimeo.com/video/401102477?h=ce693d66c6
      //   - https://vimeo.com/823568088/8306c3d3f8
      //   - https://vimeo.com/823568088/8306c3d3f8?share=copy
      //   - https://player.vimeo.com/video/823568088?h=8306c3d3f8
      //   - https://player.vimeo.com/video/823568088?h=8306c3d3f8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479
      // - Also supports relative URLs:
      //   - //player.vimeo.com/video/25451551
      // - Supported Bunny.net URL formats:
      //   - https://iframe.mediadelivery.net/embed/63923/07b04ab3-1d70-44fa-abee-b5c299b9abcc
      //   - https://video.bunnycdn.com/play/63923/07b04ab3-1d70-44fa-abee-b5c299b9abcc
      //   - Embed code
      // - Supported Canva.com
      //   - https://www.canva.com/design/DAF79MZzeck/watch?embed
      //   - Embed code
      var urlCopy = url
      var ua = navigator.userAgent
      var nav = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

      let src = false
      url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/)
      if (RegExp.$3.indexOf('youtu') > -1) {
        if (nav[1] === 'Chrome' && autoplay) {
          src = '//www.youtube.com/embed/' + RegExp.$6 + '?showinfo=0&rel=0&modestbranding=1&mute=1'
        } else {
          src = '//www.youtube.com/embed/' + RegExp.$6 + '?showinfo=0&rel=0&modestbranding=1'
        }
      } else if (RegExp.$3.indexOf('vimeo') > -1) {
        var vimeoRegex = /(vimeo\.com|player\.vimeo\.com\/video)\/(\d+)(\/(\w+))?(\?h=\w+[^&]*)?((\?\w+=[^&]+)*)?/
        var matchVimeo = urlCopy.match(vimeoRegex)
        var videoId = matchVimeo[2]
        var secondId = matchVimeo[4]
        var hParam = matchVimeo[5]
        var slugVimeo
        switch (true) {
          case (videoId !== undefined && secondId === undefined && hParam === undefined):
            slugVimeo = videoId + '?'
            break
          case (videoId !== undefined && secondId !== undefined && hParam === undefined):
            slugVimeo = videoId + '?h=' + secondId + '&'
            break
          case (videoId !== undefined && secondId === undefined && hParam !== undefined):
            slugVimeo = videoId + hParam + '&'
            break
          default:
            slugVimeo = ''
        }
        if (nav[1] === 'Chrome' && autoplay) {
          src = '//player.vimeo.com/video/' + slugVimeo + 'sidedock=0&title=0&byline=0&portrait=0&muted=1'
        } else {
          src = '//player.vimeo.com/video/' + slugVimeo + 'sidedock=0&title=0&byline=0&portrait=0'
        }
      } else if (url.includes('amazon')) {
        src = url
      } else if (url.includes('mediadelivery')) {
        // bunny.net embed code
        const iframeSrcMatch = url.match(/src=["'](.*?)["']/i)
        if (iframeSrcMatch) {
          src = iframeSrcMatch[1]
        } else {
          // bunny.net video url
          src = this.parseBunnyVideos(url)
        }
      } else if (url.includes('bunny')) {
        // bunny.net video url
        src = this.parseBunnyVideos(url)
      } else if (url.includes('canva')) {
        // canva.com video url
        src = this.parseCanvaVideos(url)
      }
      return src
    },

    parseCanvaVideos (url) {
      if (url.startsWith('https://www.canva.com/design/')) {
        return url + '?embed'
      } else {
        const hrefRegex = /href="([^"]+)"/
        const match = url.match(hrefRegex)
        if (match && match[1]) {
          let parsedUrl = match[1].replace(/&#x2F;/g, '/')
          parsedUrl = parsedUrl.split('?')[0] + '?embed'
          return parsedUrl
        }
      }
      return url
    },

    parseBunnyVideos (url) {
      var urlParts = url.split('/')
      var code1 = urlParts[urlParts.length - 2]
      var code2 = urlParts[urlParts.length - 1]
      var newURL = `https://iframe.mediadelivery.net/embed/${code1}/${code2}`
      return newURL
    },

    parseScriptTags (script) {
      let exp = /<script[^>]*>(.*?)<\/script[^>]*>/
      let result = exp.exec(script)
      return result.length ? result[0] : false
    },

    pascalCaseToSlug (string) {
      return string.split(/(?=[A-Z])/).join('-').toLowerCase()
    },

    rgbToHex (rgb, alpha = false) {
      rgb = rgb.split('(')[1].split(')')[0].split(',')

      let r = (+rgb[0]).toString(16)
      let g = (+rgb[1]).toString(16)
      let b = (+rgb[2]).toString(16)

      if (r.length === 1) {
        r = '0' + r
      }
      if (g.length === 1) {
        g = '0' + g
      }
      if (b.length === 1) {
        b = '0' + b
      }

      if (alpha) {
        let a = Math.round(+rgb[3] * 255).toString(16)

        if (a.length === 1) {
          a = '0' + a
        }

        return '#' + r + g + b + a
      }

      return '#' + r + g + b
    },

    setCssVariable (variable, newValue) {
      document.documentElement.style.setProperty(variable, newValue)
    },

    setPathContrastClass (color) {
      if (color) {
        let rgb = this.hexToRgb(color)
        let brightness = Math.round(((parseInt(rgb[0]) * 299) +
          (parseInt(rgb[1]) * 587) +
          (parseInt(rgb[2]) * 114)) / 1000)
        return (!(brightness > 125)) ? 'board-column-path-contrast' : ''
      } else {
        return ''
      }
    },

    setPathTextColor (backgroundColor) {
      let rgb = this.hexToRgb(backgroundColor)
      let brightness = Math.round(((parseInt(rgb[0]) * 299) +
        (parseInt(rgb[1]) * 587) +
        (parseInt(rgb[2]) * 114)) / 1000)
      return (!(brightness > 125)) ? '#ffffff' : '#5d5d5d'
    },

    showNativePlayer (videoUrl) {
      return videoUrl.includes('amazon')
    },

    stringCapitalized (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    stringToSlug (str) {
      // trim
      str = str.replace(/^\s+|\s+$/g, '')
      str = str.toLowerCase()
      // remove accents, swap ñ for n, etc
      let from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      let to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0; i < from.length; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }
      // remove invalid chars
      str = str.replace(/[^a-z0-9 -]/g, '')
      // collapse whitespace and replace by -
      str = str.replace(/\s+/g, '-')
      // collapse dashes
      str = str.replace(/-+/g, '-')
      return str
    },

    switchAsideNavigationMenu () {
      this.showAsideNavigationMenu = !this.showAsideNavigationMenu
    },

    topPage () {
      // for Safari
      document.body.scrollTop = 0
      // for Chrome, Firefox, IE and Opera
      document.documentElement.scrollTop = 0
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$utils = utils
  }
}
